import { Component, OnInit } from '@angular/core';
import { register } from 'swiper/element/bundle';
import { TranslateService } from '@ngx-translate/core';
import { GetDataService } from 'src/providers/get-data.service';
import { environment } from 'src/environments/environment';

register();
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private translateService : TranslateService,
    private getData : GetDataService,) {
    this.translateService.setDefaultLang('en');
    this.translateService.addLangs(['en', 'gu', 'hi', 'be']);
    let langId= localStorage.getItem('LanguageID')
    if(langId == null){
      localStorage.setItem('LanguageID', environment.Eng);
      this.changeLanguage(environment.Eng)
    }else{
      this.changeLanguage(langId)
    }
  }


  changeLanguage(id:any){
    if(id === environment.Eng){
      let language = 'en';
      this.translateService.use(language);
    }else if(id === environment.Guj){
      let language = 'gu';
      this.translateService.use(language);
    }else if(id === environment.Hin){
      let language = 'hi';
      this.translateService.use(language);
    }else if(id === environment.Ben){
      let language = 'be';
      this.translateService.use(language);
    }else{
      let language = 'en';
      this.translateService.use(language);
    }
  }
}
